import {
    MASS_DE_PSEUDO_REQUEST,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isMassDePseudoLoading = (state) =>
    ArrayContains(state.careProvider.openRequests, [
        MASS_DE_PSEUDO_REQUEST,
    ]);